import ProfessionalForm from '../components/ProfessionalTabs';

export default props => {
    return <ProfessionalForm />;
};
